import WrapperService from '@/modules/core/services/wrapper-service';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/tag';
const serviceName = "Tag-Service: ";

export default class TagService {
    
    static async readAllFromAPI(successF, errorF) {
        await WrapperService.get(API_URL, null, serviceName, successF, errorF);
    }

}